









import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import adminDashboard from "./admin/index.vue";
import { ResCode } from "@/api/baseDefine";
import { overviewRequest, OverviewReq } from "@/api/admin";
@Component({
  components: {
    adminDashboard
  }
})
export default class Dashboard extends Vue {
  private currentRole: string = "adminDashboard";
  private url =
    "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg";
  get name() {
    return UserModule.name;
  }

  get roles() {
    return [UserModule.roleName];
  }

  get logo() {
    return UserModule.companyLogo;
  }

  private created() {
    let style = {
      "color": "teal",
      "font-size":"25px"
    }
    this.$notify({
      title: "welcome",
      message: this.$createElement(
        "i",
        { style: style },
        "hello!" + UserModule.name
      ),
      type: "success"
    });
  }
}
